(function () {
	'use strict';

	function titleHeight($window) {
		return {
			restrict: 'A',
			link: function (scope, element, attributes) {
				var parents = document.querySelectorAll('.' + attributes.class) || [];
				var tallest = 0;

				function calculateTallest() {
					for (var i=0, l=parents.length; i<l; i++) {
						var childHeight = angular.element(parents[i]).children()[0].offsetHeight || 0;
						tallest = (childHeight > tallest ? childHeight : tallest);
					}
					setHeight();
				}

				calculateTallest();


				function setHeight() {
					setTimeout(function () {
						element[0].style.height = tallest + 'px';
					}, 0);
				}

				if (parents && parents.length) {
					calculateTallest();

					angular.element($window).bind('resize', function() {
						tallest = 0;
						calculateTallest();
					});
				}
			}
		};
	}

	titleHeight.$inject = ['$window'];

	angular.module('KimaMain').directive('titleHeight', titleHeight);

})();